import { DotPath } from '@agilepoint/utils-common';

export const hasError = (path: string, errors?: object) => Boolean((new DotPath(path)).navigate(errors));
